import { Modal } from 'antd';
import { ExportOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import ZoomIcon from 'src/assets/zoom.svg';

const ZoomAlert = ({
  isBasicModalVisible,
  handleBasicModalOk,
  handleOpenInNewTab,
}) => {
  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <img src={ZoomIcon} alt="Zoom" className="w-6 h-6" />
          <div className="flex flex-col">
            <span className="text-base font-semibold leading-none text-gray-900">
              Zoom meeting has started {'\u00A0'} 🚀
            </span>
          </div>
        </div>
      }
      open={isBasicModalVisible}
      width={560}
      centered
      maskClosable
      closable={false}
      destroyOnClose
      maskStyle={{
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
      footer={
        <div className="flex items-center justify-end gap-2">
          <button
            onClick={handleBasicModalOk}
            className="px-4 py-2 bg-[#00d090] text-white rounded-md hover:bg-[#178d6a] transition-colors duration-200 font-medium"
          >
            Meeting ended? Close.
          </button>
        </div>
      }
    >
      <div className="p-1">
        <div className="rounded-xl border border-indigo-100 bg-gradient-to-br from-indigo-50 to-white p-4 shadow-[inset_0_0_0_1px_rgba(99,102,241,0.08)]">
          <div className="mb-2 flex items-center gap-2">
            <CheckCircleTwoTone twoToneColor="#52c41a" />
            <h4 className="m-0 text-sm font-medium text-gray-900">
              Aura AI has joined the meeting
            </h4>
          </div>
          <p className="text-sm text-gray-600">
            Please don’t close or reload this page.
            <div className="mt-2">
              If you need to use this app, open this in a
              <button
                onClick={handleOpenInNewTab}
                className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-indigo-600 hover:underline"
                type="button"
              >
                new tab
                <ExportOutlined className="text-xs" />
              </button>
              .
            </div>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ZoomAlert;
